import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from '../admin.service';

export interface ProjectElement {
  date: number;
  name: string;
  parts: number;

}

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  ELEMENT_DATA: ProjectElement[] = [];
  dataSource = new MatTableDataSource<ProjectElement>(this.ELEMENT_DATA);
  displayedColumns: string[] = ['createdAt', 'activityKey', 'rawMessage'];
  
  notificationDetails: any;
  notificationCount: any;
  pageIndex = 0;
  page_size = 10;
  total_count: number = 0;
  page_count: number = 1;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  perpage: number;
  loading: boolean = true;

  constructor(private datePipe: DatePipe,private toastr: ToastrService, private adminService: AdminService) {
    this.dataSource = new MatTableDataSource<ProjectElement>();
   }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.page_size = 10;
    this.getNotification();
  }

  getNotification(removeRowCount = 0): Promise<any> {
    this.loading = true;
    return new Promise((resolve) => {
      this.adminService.getNotificationDetails(this.page_count - 1, this.page_size).subscribe((resp:any)=>{
        this.loading = false;    
        this.pageIndex = this.page_count - 1;
            resp.data[0].list.forEach((cust: any) => {
              cust.createdAt = this.datePipe.transform(
                cust.createdAt,
                "dd MMM yyyy"
              );
            });
            if (this.page_count == 1) {
              this.dataSource.data = resp.data[0].list;
            } else {
              if (removeRowCount > 0 && removeRowCount < 10) {
                this.dataSource.data = this.dataSource.data.concat(
                  resp.data[0].list.slice(0, removeRowCount)
                );
                this.total_count = resp.data[0].total_count;
              } else {
                this.dataSource.data = this.dataSource.data.concat(
                  resp.data[0].list
                );
                this.total_count = resp.data[0].total_count;
              }
            }
            if (this.page_count == 1) {
              this.total_count = resp.data[0].total_count;
            }
            this.paginator.length = this.total_count;
            this.dataSource.paginator = this.paginator;
            resolve(null);
          },
          (error) => {
            this.loading = false;
            this.toastr.error('Something went Wrong', 'Error');
            resolve(null);
          }
        );
    });
  }

  paginationChange(event: any) {
    this.page_size = event.pageSize;
    if (event?.previousPageIndex > event.pageIndex) {
      this.page_count = this.page_count - 1;

      this.getNotification().then((result) => {
        this.paginator.length = event.length = this.total_count;
      });
    } else if (event?.previousPageIndex < event.pageIndex) {
      this.paginator.length = event.length = this.total_count;

      this.page_count += 1;

      this.getNotification().then((result) => {
        this.paginator.length = event.length = this.total_count;
      });
    } else {
      this.getNotification().then((result) => {
        this.paginator.length = event.length = this.total_count;
      });
    }
  }


}
